import { PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Scale } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools/pds-compare')({
    staticData: {
        breadcrumb: {
            title: 'PDS compare',
        },
        featureFlag: 'enable-pds-comparison',
        modules: ['pds-compare'],
        permissions: [PERMISSIONS.MARKET_PDS_ACCESS],
        ui: {
            icon: Scale,
            title: 'PDS compare',
            subtitle: 'Compare product disclosure statements across insurers and products',
            useTitleForChildren: true,
        },
    },
    component: Outlet,
});
